import React, { useState } from 'react';
import { Col, Form, FormControl } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { sendAlert } from '../../../actions/utils';
import { SimpleCenteredModal, ImportModal, Icon, ButtonTooltip } from '../../../components';
import DirectoryNodeNew from './DirectoryNodeNew';
import DirectoryNodeEdit from './DirectoryNodeEdit';
import DirectoryNodeBoxes from './DirectoryNodeBoxes';
import {
  importTemplateDirectoryNodeRequest,
  preImportDirectoryNodeRequest,
  importDirectoryNodeRequest
} from '../../../requests/directoryNodes';
import DocumentsDatatable from '../../Document/DocumentDataTable';
import { downloadAllEmployeeDocumentsRequest } from '../../../requests/documents';

const DirectoryNodeIndex = ({ employeeId, rrhh, employeePermissions }) => {
  const [moreData, setMoreData] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [search, setSearch] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const dispatch = useDispatch();

  const handleSuccessCreate = (reloadFolder = () => { }) => {
    setModalShow(false);
    reloadFolder();
  };

  const handleTemplate = (folderId, values) => {
    importTemplateDirectoryNodeRequest(folderId, {
      employeeId,
      ...values
    });
  };

  const onDropUploaded = (folderId, values) => {
    preImportDirectoryNodeRequest(folderId, {
      employeeId,
      ...values
    });
  };

  const handleImport = (folderId, values) => {
    importDirectoryNodeRequest(folderId, {
      employeeId,
      ...values
    });
  };

  const handleOpenModal = (parentId, parentName, fileType, reloadFolder) => {
    setModalBody(
      <DirectoryNodeNew
        onSuccess={() => handleSuccessCreate(() => reloadFolder(parentId))}
        employeeId={employeeId}
        parentId={parentId}
        fileType={fileType}
        parentName={parentName}
        onHide={() => setModalShow(false)}
      />
    );
    if (fileType === 'folder') {
      setModalTitle('Crear Carpeta');
    } else {
      setModalTitle('Agregar Archivos');
    }
    setModalShow(true);
  };

  const handleEditModal = (folderId, folderName, setOnRequest, reloadFolder = () => { }) => {
    setModalShow(true);
    setModalTitle('Cambiar Nombre');
    setModalBody(
      <DirectoryNodeEdit
        onSuccess={() => handleSuccessCreate(reloadFolder)}
        folderId={folderId}
        employeeId={employeeId}
        folderName={folderName}
        onHide={() => setModalShow(false)}
        setOnRequest={setOnRequest}
      />
    );
  };

  const handleImportModalExceptions = error => {
    if (error?.response?.status === 422) {
      const alertInfo = <pre>{error?.response?.data?.message}</pre>;
      setModalTitle('Información Relevante');
      setModalShow(true);
      setModalBody(alertInfo);
    } else {
      dispatch(sendAlert({ kind: 'error', message: error?.response?.data?.message }));
    }
  };

  const handleOpenImportModal = folder => {
    setModalShow(true);
    setModalTitle('Importar Plantilla de Actualización');
    setModalBody(
      <ImportModal
        onDropUploaded={values => onDropUploaded(folder.id, values)}
        handleTemplate={values => handleTemplate(folder.id, values)}
        onHide={values => handleImport(folder.id, values)}
        hideModal={handleSuccessCreate}
        handleExceptions={handleImportModalExceptions}
      />
    );
  };

  const handleDownload = () => {
    downloadAllEmployeeDocumentsRequest({
      employeeId,
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Se ha iniciado el proceso de descarga de archivos' }));
      }
    });
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        {rrhh ? (
          <ButtonTooltip
            variant="circle-primary"
            className="ml-3 mr-2 mb-3 btn-circle"
            text="Descargar Archivos"
            onClick={() => handleDownload()}
          >
            <Icon icon="download-2" />
          </ButtonTooltip>
        ) : (
          <Col />
        )}

        <Form.Group className="w-100 max-width-290 ml-2 mr-2 mb-1">
          <FormControl
            placeholder="Buscar"
            name="textInput"
            value={search}
            onChange={e => {
              setSearch(e.target.value);
              setMoreData(!moreData);
            }}
          />
        </Form.Group>
      </div>
      {search === '' ? (
        <DirectoryNodeBoxes
          employeeId={employeeId}
          handleOpenCenterModal={handleOpenModal}
          handleOpenImportModal={handleOpenImportModal}
          handleEditModal={handleEditModal}
          moreDataCenterModal={moreData}
          rrhh={rrhh}
          employeePermissions={employeePermissions}
        />
      ) : (
        <DocumentsDatatable
          customParams={{ filter_employee: employeeId, employee_query: search, with_directory: true }}
          moreData={moreData}
          setMoreData={setMoreData}
          employeeSearch
          allowedActions={['show', 'download']}
          employeePermissions={employeePermissions}
          rrhh={rrhh}
        />
      )}
      <SimpleCenteredModal title={modalTitle} body={modalBody} show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default DirectoryNodeIndex;
